import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import VideosList from "../../components/videos/VideosList";
export default function Videos() {
  useEffect(() => {
    document.title = "Videos";
  });
  return (
    <>
      <Navbar />
      <Container>
        <div className="px-3 py-20 bg-opacity-10">
          <h2 className="text-4xl text-center ">Videos</h2>
          <div className="w-full flex">
            <Link to={"/admin/addVideo"} className="btn ml-auto">
              Add Video
            </Link>
          </div>
          <div className="overflow-x-auto mt-4">
            <VideosList />
          </div>
        </div>
      </Container>
    </>
  );
}
